import { computed, ComputedRef } from "vue";
import { useStore } from "vuex";
import { CategoryDocument, CategoryFilters } from "@/types/category.ts";

export const key = Symbol("filterControls");

export interface FilterControlsApi {
  show: ComputedRef<boolean>;
  toggleDisabled: (type: string) => Promise<void>;
}

export default function createData(): FilterControlsApi {
  const store = useStore();
  return {
    show: computed(() => store.getters.showCMS),
    toggleDisabled: async (type) => {
      let categoryID;
      if (store.state.route.name === "Home") {
        categoryID = store.getters.getStoreVar(
          "Home",
          "styling",
          "dropdown",
          "gridCategoryId"
        );
      } else {
        categoryID = store.state.route.params.categoryID;
      }
      const category: CategoryDocument =
        store.getters["api/category"](categoryID);
      if (!category) {
        return;
      }
      const cats: CategoryFilters = category.filterCategories;
      cats[type as keyof CategoryFilters] =
        !cats[type as keyof CategoryFilters];
      await store.dispatch("api/saveSiteData", {
        dataKey: ["Category", "page", "filters", "filterCategories"],
        value: cats,
        categoryID,
      });
    },
  };
}

const injectError = `Inject has failed for FilterControlsApi`;

export const defaultApi: FilterControlsApi = {
  show: computed(() => false),
  toggleDisabled: async () => console.error(injectError),
};

export const storybookApi: FilterControlsApi = {
  show: computed(() => false),
  toggleDisabled: async (type) => alert(`toggleDisabled ${type}`),
};
